import { AxiosRequest } from "_services/api";
import { HttpError } from "_services/api/HttpError";
import { HttpResponse } from "_services/api/HttpResponse";
import {
  IData,
  IHttpError,
  IHttpResponse,
} from "_services/api/interface/HttpResponse";
import { getToken, getTokenKeyCloak } from "_services/auth";
import { alertaErro, alertaSucesso } from "components/Alerta";
import { useState } from "react";
import { ICadastroProxy } from "../Interfaces/ICadastroProxy";

export function useProxy() {
  const api = AxiosRequest.makeApi(process.env.REACT_APP_API_DEBITOS);
  const token = getTokenKeyCloak();
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<IHttpResponse<IData | any>>();

  async function cadastroProxy(dados: ICadastroProxy) {
    setLoading(true);
    try {
      const { status, data } = await api.post(`/v1/proxy/lote`, dados, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      const response = new HttpResponse(false, status, data);
      alertaSucesso("Sucesso", "Proxy cadastrado com sucesso!");
      setError(response);
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      alertaErro(
        "Ocorreu um erro",
        response?.data?.message ?? "Não foi possivel geral ZIP"
      );
      return response;
    } finally {
      setLoading(false);
    }
  }

  async function renovarProxyScrape() {
    setLoading(true);
    try {
      const { status, data } = await api.post(
        `/v1/proxy/importar/proxyscrape`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const response = new HttpResponse(false, status, data);
      alertaSucesso(
        "Sucesso",
        `Proxyscrape renovado! ${data} proxies ativos.`
      );
      setError(response);
      await listar();
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      alertaErro(
        "Ocorreu um erro",
        response?.data?.message ?? "Não foi possível renovar o proxyscrape"
      );
      return response;
    } finally {
      setLoading(false);
    }
  }

  async function renovarScrapeless() {
    setLoading(true);
    try {
      const { status, data } = await api.post(
        `/v1/proxy/importar/scrapeless`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const response = new HttpResponse(false, status, data);
      alertaSucesso(
        "Sucesso",
        `Scrapeless renovado! ${data} proxies ativos.`
      );
      setError(response);
      await listar();
      return response;
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      alertaErro(
        "Ocorreu um erro",
        response?.data?.message ?? "Não foi possível renovar o scrapeless"
      );
      return response;
    } finally {
      setLoading(false);
    }
  }

  async function listar() {
    setLoading(true);
    try {
      const { status, data } = await api.get(`/v1/proxy`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = new HttpResponse(false, status, data);
      setError(response);
      setDados(data);
    } catch (error: IHttpError<IData, any> | any) {
      const response = new HttpError<IData>(true, error);
      if (response.status === 404) {
        setDados([]);
        return response;
      }
      alertaErro("Ocorreu um erro", response?.data?.message);
      return response;
    } finally {
      setLoading(false);
    }
  }

  return {
    error,
    setLoading,
    loading,
    cadastroProxy,
    renovarProxyScrape,
    renovarScrapeless,
    listar,
    dados,
  };
}
